import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "py-4 sm:py-8 sm:p-8" }
const _hoisted_2 = { class: "mb-10 flex flex-wrap gap-4 items-center justify-between" }
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = { class: "relative group" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "h-10 w-10 rounded-full bg-zinc-800 flex items-center justify-center border border-white/10 ring-2 ring-white/5"
}
const _hoisted_7 = { class: "text-sm font-medium text-white" }
const _hoisted_8 = { class: "flex items-center gap-2" }
const _hoisted_9 = { class: "truncate font-mono text-xs text-zinc-400" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "flex items-center gap-2" }
const _hoisted_12 = { class: "w-48 truncate font-mono text-xs text-zinc-400" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "flex justify-end gap-2" }
const _hoisted_15 = {
  key: 0,
  class: "space-y-4 md:hidden text-left"
}
const _hoisted_16 = { class: "flex items-center gap-3" }
const _hoisted_17 = { class: "relative group" }
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 1,
  class: "h-10 w-10 rounded-full bg-zinc-800 flex items-center justify-center border border-white/10 ring-2 ring-white/5"
}
const _hoisted_20 = { class: "flex flex-col" }
const _hoisted_21 = { class: "flex items-center gap-2" }
const _hoisted_22 = { class: "text-white font-bold text-lg" }
const _hoisted_23 = { class: "flex flex-col items-end gap-2" }
const _hoisted_24 = { class: "flex items-center gap-1" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "flex items-center gap-2 bg-white/5 p-2 rounded justify-between" }
const _hoisted_29 = { class: "font-mono text-xs text-zinc-400 truncate max-w-[250px]" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "flex items-center gap-2 bg-white/5 p-2 rounded justify-between" }
const _hoisted_32 = { class: "font-mono text-xs text-zinc-400 truncate max-w-[250px]" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "flex items-center justify-between pt-2" }
const _hoisted_35 = { class: "flex flex-col" }
const _hoisted_36 = {
  key: 1,
  class: "text-center py-12 text-zinc-500"
}
const _hoisted_37 = { class: "text-white" }
const _hoisted_38 = { class: "grid gap-4 py-2" }
const _hoisted_39 = { class: "grid gap-2" }
const _hoisted_40 = {
  key: 0,
  class: "text-xs text-red-400"
}
const _hoisted_41 = { class: "flex items-center gap-1" }
const _hoisted_42 = { class: "flex items-center gap-1" }
const _hoisted_43 = { class: "grid sm:grid-cols-2 gap-6 py-4" }
const _hoisted_44 = {
  key: 0,
  class: "grid gap-2 col-span-full"
}
const _hoisted_45 = { class: "flex items-center gap-2" }
const _hoisted_46 = {
  key: 1,
  class: "grid gap-2 col-span-full"
}
const _hoisted_47 = { class: "grid gap-2 col-span-full" }
const _hoisted_48 = { class: "flex items-center gap-2" }
const _hoisted_49 = { class: "grid gap-2 col-span-full" }
const _hoisted_50 = {
  key: 0,
  class: "mt-2 p-2 bg-zinc-500/5 border border-zinc-500/20 rounded-md text-zinc-400 text-xs"
}
const _hoisted_51 = { class: "grid gap-4" }
const _hoisted_52 = { class: "grid gap-4" }
const _hoisted_53 = { class: "grid gap-2 sm:col-span-2" }
const _hoisted_54 = { class: "col-span-full" }
const _hoisted_55 = { class: "grid gap-2 sm:col-span-2" }
const _hoisted_56 = {
  key: 0,
  class: "grid gap-2 sm:col-span-2"
}
const _hoisted_57 = { class: "flex gap-6 sm:col-span-2 flex-row" }
const _hoisted_58 = { class: "flex items-center gap-2" }
const _hoisted_59 = { class: "flex items-center gap-2" }
const _hoisted_60 = { class: "grid sm:grid-cols-2 gap-6 py-4" }
const _hoisted_61 = { class: "grid gap-2 sm:col-span-2" }
const _hoisted_62 = { class: "grid gap-2 sm:col-span-2" }
const _hoisted_63 = { class: "grid gap-2 sm:col-span-2" }
const _hoisted_64 = { class: "grid gap-2 sm:col-span-2" }
const _hoisted_65 = { class: "grid gap-2 sm:col-span-2" }
const _hoisted_66 = { class: "flex items-center gap-2" }
const _hoisted_67 = { class: "grid gap-6 py-6" }
const _hoisted_68 = { class: "flex items-center gap-2" }
const _hoisted_69 = { class: "grid gap-4" }
const _hoisted_70 = { class: "flex items-center gap-2" }
const _hoisted_71 = {
  key: 0,
  class: "grid gap-2"
}
const _hoisted_72 = { class: "grid sm:grid-cols-2 gap-6 py-4" }
const _hoisted_73 = {
  key: 0,
  class: "grid gap-2 col-span-full"
}
const _hoisted_74 = { class: "grid gap-4 col-span-full" }
const _hoisted_75 = { class: "grid gap-2 col-span-full" }
const _hoisted_76 = { class: "flex justify-between items-center text-[10px] text-zinc-500" }
const _hoisted_77 = { class: "grid gap-2 col-span-full" }
const _hoisted_78 = { class: "flex justify-between items-center text-[10px] text-zinc-500" }
const _hoisted_79 = {
  key: 0,
  class: "w-full col-span-7 md:col-span-5"
}

import { ref, onMounted, watch, computed } from 'vue'
import {
  ArrowsUpDownIcon,
  // RobotIcon,
  ClipboardIcon,
  PencilIcon,
  TrashIcon,
  PlayIcon,
  DocumentDuplicateIcon,
} from '@heroicons/vue/24/outline'
import MobileCard from '@/components/ui/mobile-card/MobileCard.vue'
import MobileDataLabel from '@/components/ui/mobile-card/MobileDataLabel.vue'
import {
  Dialog,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogScrollContent,
  DialogTitle,
} from '@/components/ui/dialog'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip"
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { BotIcon, Loader2, CircleHelp, SquareTerminal, User } from 'lucide-vue-next'

import RegisterButton from '@/components/ui/register-button/RegisterButton.vue'
import Table from '@/components/ui/table/Table.vue'
import TableHeader from '@/components/ui/table/TableHeader.vue'
import TableHead from '@/components/ui/table/TableHead.vue'
import TableBody from '@/components/ui/table/TableBody.vue'
import TableRow from '@/components/ui/table/TableRow.vue'
import TableFallback from '@/components/ui/table/TableFallback.vue'
import TableCell from '@/components/ui/table/TableCell.vue'
import Pagination from '@/components/ui/pagination/Pagination.vue'
import TableContainer from '@/components/ui/table/TableContainer.vue'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { Textarea } from '@/components/ui/textarea'
import { CreateBotDTO, GetAllBotsParams, useBot } from '@/composables/useBot'
import { Bot } from '@/interfaces/Bot'
import { Pagination as IPagination } from '@/interfaces/Pagination'
import TableRowSkeleton from '@/components/ui/table/TableRowSkeleton.vue'
import StatusBadge from '@/components/ui/badge/StatusBadge.vue'
import { useToast } from '@/components/ui/toast'
import { Switch } from '@/components/ui/switch'
import { BotStatusEnum } from '@/enums/bots/BotStatusEnum'
import DeleteConfirmationDialog from '@/components/ui/delete-dialog/DeleteConfirmationDialog.vue'
import PageTitle from '@/components/ui/page/PageTitle.vue'
import PageDescription from '@/components/ui/page/PageDescription.vue'
import { useRoute } from 'vue-router'
import FileUpload from '@/components/ui/upload/FileUpload.vue'
import { MediaPlacementEnum } from '@/enums/media/MediaPlacementEnum'
import TelegramMessagePreview, { MessagePreviewProp } from '@/components/ui/telegram/TelegramMessagePreview.vue'
import { usePaymentGatewayIntegration } from '@/composables/usePaymentGatewayIntegration'
import MultiAudioUpload from '@/components/ui/upload/MultiAudioUpload.vue'
import { MediaTypeEnum } from '@/enums/media/MediaTypeEnum'
import { Media } from '@/interfaces/Media'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { BotTypeEnum, BotTypeEnumLabels } from '@/enums/bots/BotTypeEnum'
import { BotCommandActionTypeEnum } from '@/enums/bots/BotCommandActionTypeEnum'
import { BotCommand } from '@/interfaces/BotCommand'
import RichTextarea from '@/components/ui/textarea/RichTextarea.vue'
// import { useOrganization } from '@/composables/useOrganization'

// Table Configuration

export default /*@__PURE__*/_defineComponent({
  __name: 'ManageBotsView',
  setup(__props) {

const tableHeaders = [
  { key: 'name', label: 'Nome', sortable: true },
  { key: 'token', label: 'Token', sortable: false },
  { key: 'link', label: 'Link', sortable: false },
  { key: 'status', label: 'Status', sortable: true },
  { key: 'actions', label: '', class: 'w-32' },
]

// const { isBetaTester } = useOrganization()
const { paymentGatewayIntegration } = usePaymentGatewayIntegration()
const tab = ref<'general' | 'pix'>('general')
const { getAll, create, update, destroy, clone, selectableBots, selectBot, selectedBot } = useBot()
const isSaving = ref(false)
const botForm = ref<Partial<CreateBotDTO>>({
  status: BotStatusEnum.ACTIVE,
})
const audios = ref<{ file: File | null, title: string, previewUrl: string }[]>([])
const editingBot = ref<Bot | undefined>()
const isDeletingBot = ref(false)
const isDeleteBotDialogOpen = ref(false)
const deletingBot = ref<number>()
const isCloneBotDialogOpen = ref(false)
const isCloningBot = ref(false)
const cloningBot = ref<Bot>()
const cloneToken = ref('')
const cloneError = ref('')
const { toast } = useToast()
const perPage = ref('10')
const route = useRoute()
const startMediaPreview = ref<string>()
const topMediaPreview = ref<string>()
const audiosPreview = ref<Media[]>([])
const deletedMediaIds = ref<number[]>([])
const profilePicPreview = ref<string>()
const showActionButton = ref(false)
const supportCommand = ref<{ enabled: boolean, username?: string }>({
  enabled: false
})

const hasChangedType = ref(false)
const botMessagesPreview = computed(() => {
  const messages = []

  if (tab.value === 'general') {
    if (botForm.value.startMedia ?? startMediaPreview.value) {
      const editingBotStartMedia = editingBot.value?.media?.find(media => media.placement === MediaPlacementEnum.START)

      messages.push({
        type: botForm.value.startMedia ? botForm.value.startMedia.type.split('/')[0] : editingBotStartMedia!.type,
        source: botForm.value.startMedia ? URL.createObjectURL(botForm.value.startMedia) : startMediaPreview.value
      })
    }

    if(botForm.value.startMessage) {
      messages.push({
        type: 'text',
        text: botForm.value.startMessage
      })
    }

    if (botForm.value.actionButtonLabel && showActionButton.value) {
      messages.push({
        type: 'button',
        text: botForm.value.actionButtonLabel
      })
    }

    if (botForm.value.topMedia ?? topMediaPreview.value) {
      const editingBotTopMedia = editingBot.value?.media?.find(media => media.placement === MediaPlacementEnum.TOP)

      messages.push({
        type: botForm.value.topMedia ? botForm.value.topMedia.type.split('/')[0] : editingBotTopMedia!.type,
        source: botForm.value.topMedia ? URL.createObjectURL(botForm.value.topMedia) : topMediaPreview.value
      })
    }

    if (audios.value.length) {
      audios.value.forEach(audio => {
        if (audio.previewUrl || audio.file) {
          messages.push({
            type: 'audio',
            source: audio.previewUrl ?? URL.createObjectURL(audio.file!)
          })
        }
      })
    }
  
    if (botForm.value.paymentPlansMessage && !showActionButton.value) {
      messages.push({
        type: 'text',
        text: botForm.value.paymentPlansMessage
      })
      messages.push({
        type: 'button',
        text: 'Plano de exemplo'
      })
      messages.push({
        type: 'button',
        text: 'Plano de exemplo'
      })
      messages.push({
        type: 'button',
        text: 'Plano de exemplo'
      })
      messages.push({
        type: 'button',
        text: 'Link de exemplo',
        isRedirectLink: true
      })
    }
  } else {
    if (botForm.value.generatingPixMessage) {
      messages.push({
        type: 'text',
        text: botForm.value.generatingPixMessage
      })
    }

    if (botForm.value.pixPaymentInstruction) {
      messages.push({
        type: 'text',
        text: botForm.value.pixPaymentInstruction
      })
    }

    if (botForm.value.displayPixQrCode) {
      messages.push({
        type: 'image',
        source: '/assets/bot/pix/qr-code-example.jpg',
      })
    }

    messages.push({
      type: 'text',
      text: '00020126850014br.gov.bcb.pix2563pix.exemplo.com.br/qr/v3/at/48d9c620-9eaj5-4972-8e98-f94881fee4705204000053039865802BR5925HOOPAY_TECNOLOGIA_SERVICO6008BRASILIA62070503***63042452',
      copyable: true
    })
    
    if (botForm.value.pixVerifyButtonLabel) {
      messages.push({
        type: 'button',
        text: botForm.value.pixVerifyButtonLabel
      })
    }

    if (botForm.value.pixGeneratedInstruction) {
      messages.push({
        type: 'text',
        text: botForm.value.pixGeneratedInstruction
      })
    }
  }

  return messages
})

// Sample data (empty for demo)
const bots = ref<IPagination<Bot>>()

// Dialog
const isBotDialogOpen = ref(false)

// Utils
const maskToken = (token: string) => {
  return `${token.slice(0, 8)}...${token.slice(-8)}`
}

const normalizeTelegramUsername = (input?: string) => {
  return (input ?? '').trim().replace(/^https?:\/\/t\.me\//i, '').replace(/^@/, '')
}

const copyToken = async (token: string) => {
  await navigator.clipboard.writeText(token)
  toast({
    title: 'Token copiado para a área de transferência',
    class: 'bg-green-500 text-white',
    duration: 1500
  })
}

const copyBotLink = async (bot: Bot) => {
  const link = `https://bot.mybotexpress.com/${bot.uuid}`
  await navigator.clipboard.writeText(link)
  toast({
    title: 'Link copiado para a área de transferência',
    class: 'bg-green-500 text-white',
    duration: 1500
  })
}

// Actions
const openNewBotDialog = () => {
  isBotDialogOpen.value = true
  editingBot.value = undefined
  audios.value = []
  deletedMediaIds.value = []
  audiosPreview.value = []
  botForm.value = { 
    status: BotStatusEnum.ACTIVE, 
    generatingPixMessage: 'Aguarde um momento...', 
    pixPaymentInstruction: 
    `✅ PIX gerado com sucesso!
🎯 {{plano}} + {{order_bump}}
💰 Valor da transação: {{valor}}

📱 Para efetuar o pagamento, basta selecionar a opção "Pagar" no seu aplicativo bancário e escolher "PIX Copia e Cola".

💠 Pix copia e cola:`,
    pixVerifyButtonLabel: 'Verificar pagamento'
  }
  supportCommand.value = { enabled: false }
  startMediaPreview.value = undefined
  topMediaPreview.value = undefined
  profilePicPreview.value = undefined
}


const closeNewBotDialog = () => {
  isBotDialogOpen.value = false
}

const sortBy = (key: string) => {
  // Implement sorting logic
  console.log('Sorting by:', key)
}

const saveBot = async () => {
  isSaving.value = true

  const commands: BotCommand[] = []
  if (supportCommand.value.enabled || supportCommand.value.username) {
    const username = normalizeTelegramUsername(supportCommand.value.username)
    commands.push({
      command: 'suporte',
      description: 'Fala com o nosso suporte',
      enabled: supportCommand.value.enabled,
      type: BotCommandActionTypeEnum.LINK,
      link: username ? `https://t.me/${username}` : ''
    })
  }
  botForm.value.commands = commands

  try {
    if (!editingBot.value) {
      await create({ ...botForm.value, audios: audios.value.map(audio => audio.file) } as CreateBotDTO)
      toast({
        title: 'Bot criado com sucesso',
        class: 'bg-green-500 text-white',
        duration: 1500
      })
      closeNewBotDialog()
      bots.value = await getAll()
    } else {
      let payload: any = { ...botForm.value, audios: audios.value.map(audio => audio.file), deletedMediaIds: deletedMediaIds.value }

      const startMedia = editingBot.value.media?.find(media => media.placement === MediaPlacementEnum.START)
      const topMedia = editingBot.value.media?.find(media => media.placement === MediaPlacementEnum.TOP)
      const profilePic = editingBot.value.media?.find(media => media.placement === MediaPlacementEnum.PROFILE_PIC)

      if (startMedia && !startMediaPreview.value) {
        payload.deletedMediaIds?.push(startMedia.id)
      }

      if (topMedia && !topMediaPreview.value) {
        payload.deletedMediaIds?.push(topMedia.id)
      }

      if (profilePic && !profilePicPreview.value) {
        payload.deletedMediaIds?.push(profilePic.id)
      }


      if (!payload.deletedMediaIds?.length) {
        delete payload.deletedMediaIds
      }

      if (!showActionButton.value) {
        payload.actionButtonLabel = ''
      }

      await update(editingBot.value.id, payload)
      toast({
        title: 'Bot editado com sucesso',
        class: 'bg-green-500 text-white',
        duration: 1500
      })
      closeNewBotDialog()

      // const index = bots.value?.data.findIndex(bot => bot.id === editingBot.value)
      // if (index !== -1 && index !== null && index !== undefined) {
      //   bots.value!.data[index] = {
      //     ...bots.value!.data[index],
      //     ...botForm.value
      //   }
      // }
      bots.value = await getAll()

      if (editingBot.value.id == selectedBot.value?.id && payload.type !== selectedBot.value?.type) {
        selectBot({ ...selectedBot.value, type: payload.type } as unknown as Bot)
      }
    }
  } finally {
    isSaving.value = false
  }
}

const editBot = (bot: Bot) => {
  editingBot.value = bot
  botForm.value = {
    name: bot.name,
    token: bot.token,
    backupToken: bot.backupToken,
    type: bot.type,
    startMessage: bot.startMessage,
    paymentPlansMessage: bot.paymentPlansMessage,
    actionButtonLabel: bot.actionButtonLabel,
    generatingPixMessage: bot.generatingPixMessage,
    pixGeneratedInstruction: bot.pixGeneratedInstruction,
    pixPaymentInstruction: bot.pixPaymentInstruction,
    pixPaymentStatusMessage: bot.pixPaymentStatusMessage,
    pixVerifyButtonLabel: bot.pixVerifyButtonLabel,
    status: bot.status,
    displayPixQrCode: bot.displayPixQrCode,
    allowSubscriptionsCommand: bot.allowSubscriptionsCommand,
    cloakerEnabled: bot.cloakerEnabled,
    profileName: bot.profileName,
    profileDescription: bot.profileDescription,
    profileAbout: bot.profileAbout,
    startMediaHasSpoiler: bot.media?.find(m => m.placement === MediaPlacementEnum.START)?.hasSpoiler ?? false,
    topMediaHasSpoiler: bot.media?.find(m => m.placement === MediaPlacementEnum.TOP)?.hasSpoiler ?? false,
  }

  const existingSupportCommand = bot.commands?.find(command => command.command === 'suporte')
  supportCommand.value = existingSupportCommand
    ? {
      enabled: existingSupportCommand.enabled,
      username: normalizeTelegramUsername(existingSupportCommand.link)
    }
    : { enabled: false }

  startMediaPreview.value = ''
  topMediaPreview.value = ''
  profilePicPreview.value = ''

  audios.value = []
  deletedMediaIds.value = []
  let _audioPreviews: any[] = []

  bot.media?.forEach(media => {
    if (media.placement === MediaPlacementEnum.START) {
      startMediaPreview.value = media.source
    } else if (media.placement === MediaPlacementEnum.TOP) {
      topMediaPreview.value = media.source
    } else if (media.placement === MediaPlacementEnum.PROFILE_PIC) {
      profilePicPreview.value = media.source
    } else if (media.type === MediaTypeEnum.AUDIO) {
      _audioPreviews.push(media)
    }
  })

  audiosPreview.value = _audioPreviews
  showActionButton.value = bot.actionButtonLabel !== null && bot.actionButtonLabel !== undefined && bot.actionButtonLabel !== ''
  isBotDialogOpen.value = true
  tab.value = 'general'
}

const deleteBot = (bot: Bot) => {
  isDeleteBotDialogOpen.value = true
  deletingBot.value = bot.id
}

const openCloneBotDialog = (bot: Bot) => {
  cloningBot.value = bot
  cloneToken.value = ''
  cloneError.value = ''
  isCloneBotDialogOpen.value = true
}

const closeCloneBotDialog = () => {
  if (isCloningBot.value) return
  isCloneBotDialogOpen.value = false
}

const confirmCloneBot = async () => {
  if (!cloningBot.value || !cloneToken.value) return

  isCloningBot.value = true
  cloneError.value = ''

  try {
    await clone(cloningBot.value.id, cloneToken.value)
    toast({
      title: 'Bot clonado com sucesso',
      class: 'bg-green-500 text-white',
      duration: 1500
    })
    isCloneBotDialogOpen.value = false
    bots.value = await getAll()
  } catch (error: any) {
    cloneError.value = error?.response?.data?.errors?.[0]?.message
      || error?.response?.data?.message
      || 'Erro ao clonar bot. Verifique o token informado.'
  } finally {
    isCloningBot.value = false
  }
}

const reloadAndGetAll = (params: GetAllBotsParams) => {
  bots.value = undefined
  getAll(params).then((data) => bots.value = data)
}

watch(() => perPage.value, () => {
  reloadAndGetAll({ perPage: perPage.value })
})

onMounted(async () => {
  bots.value = await getAll()

  if (route.query.isBotDialogOpen) {
    openNewBotDialog()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createVNode(PageTitle, null, {
            default: _withCtx(() => _cache[41] || (_cache[41] = [
              _createTextVNode(" Gerencie seus bots ")
            ])),
            _: 1
          }),
          _createVNode(PageDescription, null, {
            default: _withCtx(() => _cache[42] || (_cache[42] = [
              _createTextVNode(" Controle e organize seus bots do Telegram com facilidade. ")
            ])),
            _: 1
          })
        ]),
        _createVNode(RegisterButton, { onClick: openNewBotDialog }, {
          default: _withCtx(() => _cache[43] || (_cache[43] = [
            _createTextVNode("Cadastrar bot")
          ])),
          _: 1
        })
      ]),
      _createVNode(TableContainer, null, {
        default: _withCtx(() => [
          _cache[47] || (_cache[47] = _createElementVNode("div", { class: "mb-6 flex items-center justify-between" }, [
            _createElementVNode("h2", { class: "text-xl font-semibold text-white" }, "Bots registrados")
          ], -1)),
          _createVNode(Table, { class: "hidden md:block" }, {
            default: _withCtx(() => [
              _createVNode(TableHeader, { class: "w-full" }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tableHeaders, (header) => {
                    return _createVNode(TableHead, {
                      key: header.key,
                      class: _normalizeClass(header.class)
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createTextVNode(_toDisplayString(header.label) + " ", 1),
                          (header.sortable)
                            ? (_openBlock(), _createBlock(_unref(ArrowsUpDownIcon), {
                                key: 0,
                                class: "h-4 w-4 cursor-pointer text-zinc-500 hover:text-white",
                                onClick: ($event: any) => (sortBy(header.key))
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["class"])
                  }), 64))
                ]),
                _: 1
              }),
              _createVNode(TableBody, null, {
                default: _withCtx(() => [
                  (bots.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bots.value.data, (bot) => {
                          return (_openBlock(), _createBlock(TableRow, {
                            key: bot.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(TableCell, { class: "flex items-center gap-3" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_4, [
                                    (bot.media?.find(m => m.placement === 'profile_pic'))
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: bot.media?.find(m => m.placement === 'profile_pic')?.source,
                                          class: "h-10 w-10 rounded-full object-cover border border-white/10 ring-2 ring-white/5 transition-transform group-hover:scale-105"
                                        }, null, 8, _hoisted_5))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                          _createVNode(_unref(BotIcon), { class: "h-5 w-5 text-zinc-500" })
                                        ]))
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_7, _toDisplayString(bot.profileName || bot.name), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("div", _hoisted_9, _toDisplayString(maskToken(bot.token)), 1),
                                    _createElementVNode("button", {
                                      onClick: ($event: any) => (copyToken(bot.token)),
                                      class: "rounded-lg bg-white/5 p-1.5 text-zinc-400 opacity-0 transition-all hover:bg-white/10 hover:text-white group-hover:opacity-100"
                                    }, [
                                      _createVNode(_unref(ClipboardIcon), { class: "h-4 w-4" })
                                    ], 8, _hoisted_10)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, _toDisplayString(`https://bot.mybotexpress.com/${bot.uuid}`), 1),
                                    _createElementVNode("button", {
                                      onClick: ($event: any) => (copyBotLink(bot)),
                                      class: "rounded-lg bg-white/5 p-1.5 text-zinc-400 transition-all hover:bg-white/10 hover:text-white group-hover:opacity-100"
                                    }, [
                                      _createVNode(_unref(ClipboardIcon), { class: "h-4 w-4 text-white" })
                                    ], 8, _hoisted_13)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createVNode(StatusBadge, {
                                    status: bot.status
                                  }, null, 8, ["status"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_14, [
                                    _createVNode(_unref(Button), {
                                      variant: "ghost",
                                      size: "icon",
                                      onClick: ($event: any) => (editBot(bot))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(PencilIcon), { class: "h-4 w-4" })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_unref(Button), {
                                      variant: "ghost",
                                      size: "icon",
                                      onClick: ($event: any) => (openCloneBotDialog(bot))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(DocumentDuplicateIcon), { class: "h-4 w-4" })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_unref(Button), {
                                      variant: "ghost",
                                      size: "icon",
                                      class: "hover:text-red-400",
                                      onClick: ($event: any) => (deleteBot(bot))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(TrashIcon), { class: "h-4 w-4" })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128)),
                        (bots.value.data.length === 0)
                          ? (_openBlock(), _createBlock(TableFallback, {
                              key: 0,
                              colspan: tableHeaders.length,
                              icon: _unref(BotIcon),
                              title: "Nenhum bot encontrado",
                              description: `Clique em 'Cadastrar bot' para começar`
                            }, null, 8, ["colspan", "icon"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createBlock(TableRowSkeleton, {
                        key: 1,
                        columns: tableHeaders.length
                      }, null, 8, ["columns"]))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (bots.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                (bots.value.data.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(bots.value.data, (bot) => {
                      return (_openBlock(), _createBlock(MobileCard, {
                        key: bot.id
                      }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                              (bot.media?.find(m => m.placement === 'profile_pic'))
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: bot.media?.find(m => m.placement === 'profile_pic')?.source,
                                    class: "h-10 w-10 rounded-full object-cover border border-white/10 ring-2 ring-white/5"
                                  }, null, 8, _hoisted_18))
                                : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _createVNode(_unref(BotIcon), { class: "h-5 w-5 text-zinc-500" })
                                  ]))
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              _cache[44] || (_cache[44] = _createElementVNode("span", { class: "text-[10px] uppercase font-bold text-zinc-500 tracking-wider" }, "Bot", -1)),
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("span", _hoisted_22, _toDisplayString(bot.profileName || bot.name), 1)
                              ])
                            ])
                          ])
                        ]),
                        actions: _withCtx(() => [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("button", {
                                onClick: ($event: any) => (editBot(bot)),
                                class: "text-zinc-400 hover:text-white p-1"
                              }, [
                                _createVNode(_unref(PencilIcon), { class: "size-5" })
                              ], 8, _hoisted_25),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (openCloneBotDialog(bot)),
                                class: "text-zinc-400 hover:text-white p-1"
                              }, [
                                _createVNode(_unref(DocumentDuplicateIcon), { class: "size-5" })
                              ], 8, _hoisted_26),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (deleteBot(bot)),
                                class: "text-zinc-400 hover:text-red-400 p-1"
                              }, [
                                _createVNode(_unref(TrashIcon), { class: "size-5" })
                              ], 8, _hoisted_27)
                            ])
                          ])
                        ]),
                        content: _withCtx(() => [
                          _createVNode(MobileDataLabel, { label: "Token" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("div", _hoisted_29, _toDisplayString(maskToken(bot.token)), 1),
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (copyToken(bot.token)),
                                  class: "rounded-lg p-1.5 text-zinc-400 transition-all hover:bg-white/10 hover:text-white"
                                }, [
                                  _createVNode(_unref(ClipboardIcon), { class: "size-4 text-white" })
                                ], 8, _hoisted_30)
                              ])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(MobileDataLabel, { label: "Link do bot" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("div", _hoisted_32, _toDisplayString(`https://bot.mybotexpress.com/${bot.uuid}`), 1),
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (copyBotLink(bot)),
                                  class: "rounded-lg p-1.5 text-zinc-400 transition-all hover:bg-white/10 hover:text-white"
                                }, [
                                  _createVNode(_unref(ClipboardIcon), { class: "size-4 text-white" })
                                ], 8, _hoisted_33)
                              ])
                            ]),
                            _: 2
                          }, 1024),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _cache[45] || (_cache[45] = _createElementVNode("span", { class: "text-[10px] uppercase font-bold text-zinc-500 tracking-wider mb-1" }, "Status", -1)),
                              _createVNode(StatusBadge, {
                                status: bot.status
                              }, null, 8, ["status"])
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _createVNode(_unref(BotIcon), { class: "size-8 mx-auto mb-3 text-zinc-700" }),
                      _cache[46] || (_cache[46] = _createTextVNode(" Nenhum bot encontrado "))
                    ]))
              ]))
            : _createCommentVNode("", true),
          (bots.value?.pagination)
            ? (_openBlock(), _createBlock(Pagination, {
                key: 1,
                "onUpdate:page": _cache[0] || (_cache[0] = page => reloadAndGetAll({ page, perPage: perPage.value })),
                data: bots.value?.pagination,
                "per-page": perPage.value,
                "onUpdate:perPage": _cache[1] || (_cache[1] = ($event: any) => ((perPage).value = $event))
              }, null, 8, ["data", "per-page"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createVNode(DeleteConfirmationDialog, {
      open: isDeleteBotDialogOpen.value,
      "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((isDeleteBotDialogOpen).value = $event)),
      loading: isDeletingBot.value,
      onConfirm: _cache[3] || (_cache[3] = ($event: any) => {isDeletingBot.value = true; _unref(destroy)(deletingBot.value!).then(() => {
    _unref(toast)({
      title: 'Bot excluído com sucesso',
      class: 'bg-green-500 text-white',
      duration: 1500
    })
    isDeletingBot.value = false
    isDeleteBotDialogOpen.value = false
    const index = bots.value?.data.findIndex(bot => bot.id == deletingBot.value)
    if (index !== -1) bots.value?.data.splice(index!, 1)
  })})
    }, null, 8, ["open", "loading"]),
    _createVNode(_unref(Dialog), {
      open: isCloneBotDialogOpen.value,
      "onUpdate:open": _cache[5] || (_cache[5] = ($event: any) => ((isCloneBotDialogOpen).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DialogScrollContent), { class: "max-w-md" }, {
          default: _withCtx(() => [
            _createVNode(_unref(DialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), null, {
                  default: _withCtx(() => _cache[48] || (_cache[48] = [
                    _createTextVNode("Clonar bot")
                  ])),
                  _: 1
                }),
                _createVNode(_unref(DialogDescription), null, {
                  default: _withCtx(() => [
                    _cache[49] || (_cache[49] = _createTextVNode(" Cria um bot novo com todas as mensagens, mídias, botões, planos, order bumps, pacotes e vídeo chamadas de ")),
                    _createElementVNode("strong", _hoisted_37, _toDisplayString(cloningBot.value?.profileName || cloningBot.value?.name), 1),
                    _cache[50] || (_cache[50] = _createTextVNode(". Você só precisa informar o token do bot novo (gerado pelo @BotFather). "))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createVNode(_unref(Label), null, {
                  default: _withCtx(() => _cache[51] || (_cache[51] = [
                    _createTextVNode("Token do novo bot "),
                    _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_unref(Input), {
                  modelValue: cloneToken.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((cloneToken).value = $event)),
                  placeholder: "Insira o token fornecido pelo @BotFather"
                }, null, 8, ["modelValue"])
              ]),
              _cache[52] || (_cache[52] = _createElementVNode("div", { class: "rounded-md border border-amber-500/20 bg-amber-500/5 p-3 text-xs text-amber-200/80" }, " Grupos/canais não são clonados automaticamente: o bot novo precisa ser adicionado como administrador nos mesmos grupos do bot original antes de vinculá-los aos planos clonados. ", -1)),
              (cloneError.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString(cloneError.value), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_unref(DialogFooter), null, {
              default: _withCtx(() => [
                _createVNode(_unref(Button), {
                  variant: "ghost",
                  class: "text-white",
                  onClick: closeCloneBotDialog
                }, {
                  default: _withCtx(() => _cache[53] || (_cache[53] = [
                    _createTextVNode("Cancelar")
                  ])),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  disabled: isCloningBot.value || !cloneToken.value,
                  onClick: confirmCloneBot
                }, {
                  default: _withCtx(() => [
                    (isCloningBot.value)
                      ? (_openBlock(), _createBlock(_unref(Loader2), {
                          key: 0,
                          class: "w-4 h-4 animate-spin mr-2"
                        }))
                      : _createCommentVNode("", true),
                    _cache[54] || (_cache[54] = _createTextVNode(" Clonar bot "))
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_unref(Dialog), {
      open: isBotDialogOpen.value,
      "onUpdate:open": _cache[40] || (_cache[40] = ($event: any) => ((isBotDialogOpen).value = $event)),
      onClose: closeNewBotDialog
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DialogScrollContent), {
          class: _normalizeClass(["max-w-3xl", [botForm.value.type && botForm.value.type === _unref(BotTypeEnum).DEFAULT ? 'lg:max-w-6xl ' : 'lg:max-w-3xl' ]])
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(DialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(editingBot.value ? 'Editar bot' : 'Novo bot'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(DialogDescription), null, {
                  default: _withCtx(() => _cache[55] || (_cache[55] = [
                    _createTextVNode(" Insira as informações do seu bot do Telegram para começar. ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", {
              class: _normalizeClass(["grid gap-6", [botForm.value.type && botForm.value.type === _unref(BotTypeEnum).DEFAULT ? 'lg:grid-cols-12 ' : 'lg:grid-cols-7' ]])
            }, [
              _createVNode(_unref(Tabs), {
                defaultValue: "general",
                class: "w-full col-span-7",
                modelValue: tab.value,
                "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((tab).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(TabsList), { class: "grid grid-cols-3 w-full" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TabsTrigger), { value: "general" }, {
                        default: _withCtx(() => _cache[56] || (_cache[56] = [
                          _createTextVNode("Geral")
                        ])),
                        _: 1
                      }),
                      _createVNode(_unref(TabsTrigger), { value: "pix" }, {
                        default: _withCtx(() => _cache[57] || (_cache[57] = [
                          _createElementVNode("div", { class: "flex items-center gap-1" }, [
                            _createElementVNode("svg", {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "22",
                              height: "22",
                              viewBox: "0 0 24 24",
                              fill: "none"
                            }, [
                              _createElementVNode("path", {
                                d: "M20.9498 14.55L14.5598 20.94C13.1598 22.34 10.8598 22.34 9.44978 20.94L3.05977 14.55C1.65977 13.15 1.65977 10.85 3.05977 9.44001L9.44978 3.05C10.8498 1.65 13.1498 1.65 14.5598 3.05L20.9498 9.44001C22.3498 10.85 22.3498 13.15 20.9498 14.55Z",
                                "stroke-width": "1.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }),
                              _createElementVNode("path", {
                                d: "M6.25 6.25L17.75 17.75",
                                "stroke-width": "1.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }),
                              _createElementVNode("path", {
                                d: "M17.75 6.25L6.25 17.75",
                                "stroke-width": "1.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              })
                            ]),
                            _createTextVNode(" Configurações de Pix ")
                          ], -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_unref(TabsTrigger), { value: "commands" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_41, [
                            _createVNode(_unref(SquareTerminal)),
                            _cache[58] || (_cache[58] = _createTextVNode(" Comandos "))
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(TabsTrigger), { value: "profile" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_42, [
                            _createVNode(_unref(User)),
                            _cache[59] || (_cache[59] = _createTextVNode(" Perfil "))
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(TabsContent), { value: "general" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_43, [
                        (!_unref(paymentGatewayIntegration) && !bots.value?.data.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                              _createElementVNode("div", _hoisted_45, [
                                _createVNode(_unref(Label), null, {
                                  default: _withCtx(() => _cache[60] || (_cache[60] = [
                                    _createTextVNode("Código de indicação")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_unref(TooltipProvider), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Tooltip), { "delay-duration": 100 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(TooltipTrigger), { "as-child": "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(CircleHelp), { class: "size-5 text-primary" })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_unref(TooltipContent), {
                                          side: "top",
                                          "side-offset": 5
                                        }, {
                                          default: _withCtx(() => _cache[61] || (_cache[61] = [
                                            _createTextVNode(" Insira um código de indicação para economizar em taxas por cada venda. Após a criação do seu primeiro bot, não "),
                                            _createElementVNode("br", null, null, -1),
                                            _createTextVNode(" será mais possível preencher este campo. ")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createVNode(_unref(Input), {
                                modelValue: botForm.value.referringOrganizationUUID,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((botForm.value.referringOrganizationUUID) = $event)),
                                placeholder: "Ex: 87c3ab49-90be-4216-848c-e0dcee074b42"
                              }, null, 8, ["modelValue"])
                            ]))
                          : _createCommentVNode("", true),
                        (botForm.value.name)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                              _createVNode(_unref(Label), null, {
                                default: _withCtx(() => _cache[62] || (_cache[62] = [
                                  _createTextVNode("Username "),
                                  _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                                ])),
                                _: 1
                              }),
                              _createVNode(_unref(Input), {
                                modelValue: botForm.value.name,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((botForm.value.name) = $event)),
                                placeholder: "Ex: Meu Bot de Vendas",
                                disabled: ""
                              }, null, 8, ["modelValue"])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          class: _normalizeClass(["grid gap-2", [!botForm.value.name ? 'col-span-full' : '']])
                        }, [
                          _createVNode(_unref(Label), null, {
                            default: _withCtx(() => _cache[63] || (_cache[63] = [
                              _createTextVNode("Token do bot "),
                              _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                            ])),
                            _: 1
                          }),
                          _createVNode(_unref(Input), {
                            modelValue: botForm.value.token,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((botForm.value.token) = $event)),
                            placeholder: "Insira o token fornecido pelo @BotFather"
                          }, null, 8, ["modelValue"])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["grid gap-2", [!botForm.value.name ? 'col-span-full' : '']])
                        }, [
                          _createVNode(_unref(Label), null, {
                            default: _withCtx(() => _cache[64] || (_cache[64] = [
                              _createTextVNode("Token Reserva (Contingência)")
                            ])),
                            _: 1
                          }),
                          _createVNode(_unref(Input), {
                            modelValue: botForm.value.backupToken,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((botForm.value.backupToken) = $event)),
                            placeholder: "Caso o seu bot caia o token reserva substituirá o seu bot atual"
                          }, null, 8, ["modelValue"])
                        ], 2),
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("div", _hoisted_48, [
                            _createVNode(_unref(Switch), {
                              checked: botForm.value.cloakerEnabled,
                              "onUpdate:checked": _cache[10] || (_cache[10] = ($event: any) => ((botForm.value.cloakerEnabled) = $event))
                            }, null, 8, ["checked"]),
                            _createVNode(_unref(Label), null, {
                              default: _withCtx(() => _cache[65] || (_cache[65] = [
                                _createTextVNode("Cloaker + Anticlone")
                              ])),
                              _: 1
                            })
                          ]),
                          _cache[66] || (_cache[66] = _createElementVNode("p", { class: "text-[10px] text-zinc-500" }, " Protege o link do seu bot: só deixa passar quem acessar através do redirecionador configurado para esse bot, bloqueando acesso direto ao link, links reaproveitados/vazados e ferramentas automatizadas de cópia. ", -1))
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                          _createVNode(_unref(Label), null, {
                            default: _withCtx(() => _cache[67] || (_cache[67] = [
                              _createTextVNode("Tipo "),
                              _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                            ])),
                            _: 1
                          }),
                          _createVNode(_unref(Select), {
                            "model-value": botForm.value.type,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = (type) => { hasChangedType.value = true; botForm.value.type = type as BotTypeEnum; })
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(SelectTrigger), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(SelectValue), { placeholder: "Selecione o tipo" })
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(SelectContent), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(SelectItem), {
                                    value: _unref(BotTypeEnum).DEFAULT
                                  }, {
                                    default: _withCtx(() => _cache[68] || (_cache[68] = [
                                      _createTextVNode("Padrão")
                                    ])),
                                    _: 1
                                  }, 8, ["value"]),
                                  _createVNode(_unref(SelectItem), {
                                    value: _unref(BotTypeEnum).CHAT_FLOW
                                  }, {
                                    default: _withCtx(() => _cache[69] || (_cache[69] = [
                                      _createTextVNode("Fluxo de Chat")
                                    ])),
                                    _: 1
                                  }, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["model-value"]),
                          (botForm.value.type === _unref(BotTypeEnum).CHAT_FLOW && hasChangedType.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_50, " Vendas realizadas dentro do fluxo de chat terão uma taxa adicional de R$ 0,40 por venda. "))
                            : _createCommentVNode("", true)
                        ]),
                        (botForm.value.type && botForm.value.type === _unref(BotTypeEnum).DEFAULT)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createElementVNode("div", _hoisted_51, [
                                _createVNode(FileUpload, {
                                  preview: startMediaPreview.value,
                                  "onUpdate:preview": _cache[12] || (_cache[12] = ($event: any) => ((startMediaPreview).value = $event)),
                                  modelValue: botForm.value.startMedia,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((botForm.value.startMedia) = $event)),
                                  "has-spoiler": botForm.value.startMediaHasSpoiler,
                                  "onUpdate:hasSpoiler": _cache[14] || (_cache[14] = ($event: any) => ((botForm.value.startMediaHasSpoiler) = $event)),
                                  label: "Mídia inicial"
                                }, null, 8, ["preview", "modelValue", "has-spoiler"])
                              ]),
                              _createElementVNode("div", _hoisted_52, [
                                _createVNode(FileUpload, {
                                  preview: topMediaPreview.value,
                                  "onUpdate:preview": _cache[15] || (_cache[15] = ($event: any) => ((topMediaPreview).value = $event)),
                                  modelValue: botForm.value.topMedia,
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((botForm.value.topMedia) = $event)),
                                  "has-spoiler": botForm.value.topMediaHasSpoiler,
                                  "onUpdate:hasSpoiler": _cache[17] || (_cache[17] = ($event: any) => ((botForm.value.topMediaHasSpoiler) = $event)),
                                  label: "Mídia superior"
                                }, null, 8, ["preview", "modelValue", "has-spoiler"])
                              ]),
                              _createElementVNode("div", _hoisted_53, [
                                _createVNode(_unref(Label), { class: "flex items-center gap-2" }, {
                                  default: _withCtx(() => [
                                    _cache[71] || (_cache[71] = _createTextVNode(" Mensagem inicial ")),
                                    _createVNode(_unref(TooltipProvider), null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(Tooltip), { "delay-duration": 100 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(TooltipTrigger), { "as-child": "" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(CircleHelp), { class: "size-5 text-primary" })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_unref(TooltipContent), {
                                              side: "top",
                                              "side-offset": 5
                                            }, {
                                              default: _withCtx(() => _cache[70] || (_cache[70] = [
                                                _createTextVNode(" Insira a mensagem que será exibida "),
                                                _createElementVNode("br", null, null, -1),
                                                _createTextVNode(" quando o usuário iniciar o bot. ")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(RichTextarea, {
                                  modelValue: botForm.value.startMessage,
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((botForm.value.startMessage) = $event)),
                                  placeholder: "Ex: Este bot...",
                                  class: "min-h-[200px]",
                                  variables: [
                      { label: 'Nome', value: '{{nome}}' },
                      { label: 'Cidade', value: '{{cidade}}' },
                      { label: 'Estado', value: '{{estado}}' }
                    ]
                                }, null, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_54, [
                                _createVNode(MultiAudioUpload, {
                                  modelValue: audios.value,
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((audios).value = $event)),
                                  previews: audiosPreview.value,
                                  "delete-media-ids": deletedMediaIds.value,
                                  "onUpdate:deleteMediaIds": _cache[20] || (_cache[20] = ($event: any) => ((deletedMediaIds).value = $event))
                                }, null, 8, ["modelValue", "previews", "delete-media-ids"])
                              ]),
                              _createElementVNode("div", _hoisted_55, [
                                _createVNode(_unref(Label), { class: "flex items-center gap-2" }, {
                                  default: _withCtx(() => [
                                    _cache[73] || (_cache[73] = _createTextVNode(" Mensagem de planos ")),
                                    _createVNode(_unref(TooltipProvider), null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(Tooltip), { "delay-duration": 100 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(TooltipTrigger), { "as-child": "" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(CircleHelp), { class: "size-5 text-primary" })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_unref(TooltipContent), {
                                              side: "top",
                                              "side-offset": 5
                                            }, {
                                              default: _withCtx(() => _cache[72] || (_cache[72] = [
                                                _createTextVNode(" Mensagem que será exibida quando o "),
                                                _createElementVNode("br", null, null, -1),
                                                _createTextVNode(" usuário clica no botão de exibir planos. ")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(RichTextarea, {
                                  modelValue: botForm.value.paymentPlansMessage,
                                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((botForm.value.paymentPlansMessage) = $event)),
                                  placeholder: "Ex: Temos os planos...",
                                  class: "min-h-[150px]",
                                  variables: [
                      { label: 'Nome', value: '{{nome}}' },
                      { label: 'Cidade', value: '{{cidade}}' },
                      { label: 'Estado', value: '{{estado}}' }
                    ]
                                }, null, 8, ["modelValue"])
                              ]),
                              (showActionButton.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                    _createVNode(_unref(Label), null, {
                                      default: _withCtx(() => _cache[74] || (_cache[74] = [
                                        _createTextVNode("Texto do botão de exibir planos")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_unref(Input), {
                                      modelValue: botForm.value.actionButtonLabel,
                                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((botForm.value.actionButtonLabel) = $event)),
                                      placeholder: "Ex: Ver planos"
                                    }, null, 8, ["modelValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("div", _hoisted_58, [
                                  _createVNode(_unref(Switch), {
                                    checked: botForm.value.status === _unref(BotStatusEnum).ACTIVE,
                                    "onUpdate:checked": _cache[23] || (_cache[23] = checked => botForm.value.status = checked ? _unref(BotStatusEnum).ACTIVE : _unref(BotStatusEnum).INACTIVE)
                                  }, null, 8, ["checked"]),
                                  _createVNode(_unref(Label), null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(botForm.value.status === _unref(BotStatusEnum).ACTIVE ? 'Ativo' : 'Inativo'), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_59, [
                                  _createVNode(_unref(Switch), {
                                    checked: showActionButton.value,
                                    "onUpdate:checked": _cache[24] || (_cache[24] = (val) => { 
                        showActionButton.value = val; 
                        if (val && !botForm.value.actionButtonLabel) botForm.value.actionButtonLabel = 'Ver planos'; 
                        if (!val) botForm.value.actionButtonLabel = ''; 
                      })
                                  }, null, 8, ["checked"]),
                                  _createVNode(_unref(Label), null, {
                                    default: _withCtx(() => _cache[75] || (_cache[75] = [
                                      _createTextVNode("Botão de ver planos")
                                    ])),
                                    _: 1
                                  })
                                ])
                              ])
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(TabsContent), { value: "pix" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _createVNode(_unref(Label), null, {
                            default: _withCtx(() => _cache[76] || (_cache[76] = [
                              _createTextVNode("Mensagem enquanto gera o Pix")
                            ])),
                            _: 1
                          }),
                          _createVNode(_unref(Input), {
                            modelValue: botForm.value.generatingPixMessage,
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((botForm.value.generatingPixMessage) = $event)),
                            placeholder: "Ex: Gerando seu Pix, aguarde..."
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_62, [
                          _createVNode(_unref(Label), { class: "flex items-center gap-2" }, {
                            default: _withCtx(() => [
                              _cache[78] || (_cache[78] = _createTextVNode(" Instrução para pagamento do Pix ")),
                              _createVNode(_unref(TooltipProvider), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Tooltip), { "delay-duration": 100 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(TooltipTrigger), { "as-child": "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CircleHelp), { class: "size-5 text-primary" })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(TooltipContent), {
                                        side: "top",
                                        "side-offset": 5
                                      }, {
                                        default: _withCtx(() => _cache[77] || (_cache[77] = [
                                          _createElementVNode("span", {
                                            class: "text-primary",
                                            innerHTML: '{{plano}}'
                                          }, null, -1),
                                          _createTextVNode(": Nome do plano"),
                                          _createElementVNode("br", null, null, -1),
                                          _createElementVNode("span", {
                                            class: "text-primary",
                                            innerHTML: '{{valor}}'
                                          }, null, -1),
                                          _createTextVNode(": Valor do pix"),
                                          _createElementVNode("br", null, null, -1),
                                          _createElementVNode("span", {
                                            class: "text-primary",
                                            innerHTML: '{{order_bump}}'
                                          }, null, -1),
                                          _createTextVNode(": Order bump ")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(RichTextarea, {
                            modelValue: botForm.value.pixPaymentInstruction,
                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((botForm.value.pixPaymentInstruction) = $event)),
                            placeholder: "Ex: Escaneie o QR Code ou copie e cole o código abaixo.",
                            class: "min-h-[150px]",
                            variables: [
                    { label: 'Plano', value: '{{plano}}' },
                    { label: 'Valor', value: '{{valor}}' },
                    { label: 'Order Bump', value: '{{order_bump}}' }
                  ]
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_63, [
                          _createVNode(_unref(Label), null, {
                            default: _withCtx(() => _cache[79] || (_cache[79] = [
                              _createTextVNode("Texto do botão para verificar pagamento")
                            ])),
                            _: 1
                          }),
                          _createVNode(_unref(Input), {
                            modelValue: botForm.value.pixVerifyButtonLabel,
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((botForm.value.pixVerifyButtonLabel) = $event)),
                            placeholder: "Ex: Verificar pagamento"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_64, [
                          _createVNode(_unref(Label), null, {
                            default: _withCtx(() => _cache[80] || (_cache[80] = [
                              _createTextVNode("Instrução após gerar Pix")
                            ])),
                            _: 1
                          }),
                          _createVNode(RichTextarea, {
                            modelValue: botForm.value.pixGeneratedInstruction,
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((botForm.value.pixGeneratedInstruction) = $event)),
                            placeholder: "Ex: Após o pagamento clique no link para acessar o grupo.",
                            class: "min-h-[150px]",
                            variables: [
                    { label: 'Nome', value: '{{nome}}' }
                  ]
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_65, [
                          _createVNode(_unref(Label), null, {
                            default: _withCtx(() => _cache[81] || (_cache[81] = [
                              _createTextVNode("Mensagem de pagamento não identificado")
                            ])),
                            _: 1
                          }),
                          _createVNode(_unref(Input), {
                            modelValue: botForm.value.pixPaymentStatusMessage,
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((botForm.value.pixPaymentStatusMessage) = $event)),
                            placeholder: "Ex: Pagamento não identificado!"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_66, [
                          _createVNode(_unref(Switch), {
                            checked: botForm.value.displayPixQrCode,
                            "onUpdate:checked": _cache[30] || (_cache[30] = ($event: any) => ((botForm.value.displayPixQrCode) = $event))
                          }, null, 8, ["checked"]),
                          _createVNode(_unref(Label), null, {
                            default: _withCtx(() => _cache[82] || (_cache[82] = [
                              _createTextVNode("Exibir QR Code do Pix")
                            ])),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(TabsContent), { value: "commands" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("div", _hoisted_68, [
                          _createVNode(_unref(Switch), {
                            checked: botForm.value.allowSubscriptionsCommand,
                            "onUpdate:checked": _cache[31] || (_cache[31] = ($event: any) => ((botForm.value.allowSubscriptionsCommand) = $event))
                          }, null, 8, ["checked"]),
                          _createVNode(_unref(Label), null, {
                            default: _withCtx(() => _cache[83] || (_cache[83] = [
                              _createTextVNode("/assinaturas")
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_69, [
                          _createElementVNode("div", _hoisted_70, [
                            _createVNode(_unref(Switch), {
                              checked: supportCommand.value.enabled,
                              "onUpdate:checked": _cache[32] || (_cache[32] = ($event: any) => ((supportCommand.value.enabled) = $event))
                            }, null, 8, ["checked"]),
                            _createVNode(_unref(Label), null, {
                              default: _withCtx(() => _cache[84] || (_cache[84] = [
                                _createTextVNode("/suporte")
                              ])),
                              _: 1
                            })
                          ]),
                          (supportCommand.value.enabled)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                _createVNode(_unref(Label), null, {
                                  default: _withCtx(() => _cache[85] || (_cache[85] = [
                                    _createTextVNode("Username do Telegram de suporte")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_unref(Input), {
                                  modelValue: supportCommand.value.username,
                                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((supportCommand.value.username) = $event)),
                                  placeholder: "Ex: @suporte_botexpress"
                                }, null, 8, ["modelValue"]),
                                _cache[86] || (_cache[86] = _createElementVNode("p", { class: "text-[10px] text-zinc-500" }, "Ao usar /suporte, o bot enviará um botão que leva o cliente até esse usuário/canal no Telegram.", -1))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(TabsContent), { value: "profile" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_72, [
                        (editingBot.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                              _createVNode(_unref(Label), null, {
                                default: _withCtx(() => _cache[87] || (_cache[87] = [
                                  _createTextVNode("Nome do Bot")
                                ])),
                                _: 1
                              }),
                              _createVNode(_unref(Input), {
                                modelValue: botForm.value.profileName,
                                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((botForm.value.profileName) = $event)),
                                placeholder: "Ex: Meu Bot de Vendas"
                              }, null, 8, ["modelValue"]),
                              _cache[88] || (_cache[88] = _createElementVNode("p", { class: "text-[10px] text-zinc-500" }, "Este é o nome de exibição que aparece no perfil do bot no Telegram.", -1))
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_74, [
                          _createVNode(FileUpload, {
                            preview: profilePicPreview.value,
                            "onUpdate:preview": _cache[35] || (_cache[35] = ($event: any) => ((profilePicPreview).value = $event)),
                            modelValue: botForm.value.profilePic,
                            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((botForm.value.profilePic) = $event)),
                            label: "Foto de Perfil",
                            "show-spoiler": false
                          }, null, 8, ["preview", "modelValue"]),
                          _cache[89] || (_cache[89] = _createElementVNode("p", { class: "text-[10px] text-zinc-500" }, "A foto de perfil do seu bot.", -1))
                        ]),
                        _createElementVNode("div", _hoisted_75, [
                          _createVNode(_unref(Label), { class: "flex items-center gap-2" }, {
                            default: _withCtx(() => _cache[90] || (_cache[90] = [
                              _createTextVNode(" Sobre (Bio) ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_unref(Textarea), {
                            modelValue: botForm.value.profileAbout,
                            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((botForm.value.profileAbout) = $event)),
                            placeholder: "Ex: Assine agora e tenha acesso ao melhor conteúdo!",
                            class: "min-h-[80px]",
                            maxlength: "120"
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_76, [
                            _cache[91] || (_cache[91] = _createElementVNode("p", null, "Uma breve descrição do seu bot que aparece no perfil (Bio). Máx 120 caracteres.", -1)),
                            _createElementVNode("span", null, _toDisplayString((botForm.value.profileAbout?.length || 0)) + "/120", 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_77, [
                          _createVNode(_unref(Label), { class: "flex items-center gap-2" }, {
                            default: _withCtx(() => _cache[92] || (_cache[92] = [
                              _createTextVNode(" Descrição ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_unref(Textarea), {
                            modelValue: botForm.value.profileDescription,
                            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((botForm.value.profileDescription) = $event)),
                            placeholder: "Ex: Este bot ajuda você a gerenciar suas assinaturas...",
                            class: "min-h-[120px]",
                            maxlength: "512"
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_78, [
                            _cache[93] || (_cache[93] = _createElementVNode("p", null, "A descrição que os usuários veem quando encontram o bot e ainda não iniciaram. Máx 512 caracteres.", -1)),
                            _createElementVNode("span", null, _toDisplayString((botForm.value.profileDescription?.length || 0)) + "/512", 1)
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (botForm.value.type && botForm.value.type === _unref(BotTypeEnum).DEFAULT)
                ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                    _createVNode(TelegramMessagePreview, {
                      disableInput: true,
                      messages: botMessagesPreview.value as MessagePreviewProp[],
                      sender: botForm.value.profileName || botForm.value.name
                    }, null, 8, ["messages", "sender"])
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createVNode(_unref(DialogFooter), null, {
              default: _withCtx(() => [
                _createVNode(_unref(Button), {
                  class: "text-white",
                  variant: "ghost",
                  onClick: closeNewBotDialog
                }, {
                  default: _withCtx(() => _cache[94] || (_cache[94] = [
                    _createTextVNode("Cancelar")
                  ])),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  disabled: isSaving.value || !botForm.value.token,
                  onClick: saveBot
                }, {
                  default: _withCtx(() => [
                    (isSaving.value)
                      ? (_openBlock(), _createBlock(_unref(Loader2), {
                          key: 0,
                          class: "w-4 h-4 animate-spin"
                        }))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(editingBot.value ? 'Salvar alterações' : 'Cadastrar bot'), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})